import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientService } from './client.service';

export interface ShareSettingModel {
  id: number;
  workspaceId: number;
  mindMapId: number | null;
  deckId: number | null;
  shareKey: string;
  readonly publicUrl?: string | null;
  readonly embedUrl?: string | null;
  readonly previewUrl?: string | null;
  categoryId: number | null;
  languageCode?: string | null;
  description: string | null;
  publishedTitle: string | null;
  slug: string | null;
  allowCopy: boolean;
  allowExport: boolean;
  allowEmbed: boolean;
  publishedAt: string | null;
  publishedByUserId: number | null;
  updatedAt: string | null;
  createdAt: string;
}

export type ShareSettingCreatePayload = {
  workspaceId: number;
  mindMapId: number | null;
  deckId: number | null;
  shareKey?: string | null;
  categoryId: number | null;
  languageCode?: string | null;
  description: string | null;
  publishedTitle?: string | null;
  slug?: string | null;
  allowCopy: boolean;
  allowExport: boolean;
  allowEmbed: boolean;
  publishedAt: string | null;
  publishedByUserId: number | null;
};

export type ShareSettingUpdatePayload = ShareSettingCreatePayload & {
  id: number;
};

@Injectable({ providedIn: 'root' })
export class ShareSettingService {
  private readonly client = inject(ClientService);

  get(id: number): Observable<ShareSettingModel> {
    return this.client.get<ShareSettingModel>(`sharesetting/${id}`);
  }

  list(): Observable<ShareSettingModel[]> {
    return this.client.get<ShareSettingModel[]>('sharesetting');
  }

  create(payload: ShareSettingCreatePayload): Observable<ShareSettingModel> {
    return this.client.post<ShareSettingModel, ShareSettingCreatePayload>(
      'sharesetting',
      payload,
    );
  }

  update(payload: ShareSettingUpdatePayload): Observable<ShareSettingModel> {
    return this.client.put<ShareSettingModel, ShareSettingUpdatePayload>(
      'sharesetting',
      payload,
    );
  }

  delete(id: number): Observable<boolean | unknown> {
    return this.client.delete<boolean | unknown>(`sharesetting/${id}`);
  }

  findByMindMapId(
    items: ShareSettingModel[],
    mindMapId: number,
  ): ShareSettingModel | null {
    return items.find((item) => item.mindMapId === mindMapId) ?? null;
  }
}
